import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/layout/PrivateRoute';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Profile from './pages/Profile';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Settings from './pages/Settings';
import Clientes from './pages/Clientes';
import Zonas from './pages/Zonas';
import Tecnologias from './pages/Tecnologias';
import Planes from './pages/Planes';
import Marcas from './pages/Marcas';
import Modelos from './pages/Modelos';
import Equipos from './pages/Equipos';
import Nodos from './pages/Nodos';
import Olt from './pages/Olt';
import Mikrotik from './pages/Mikrotik';
import IpPool from './pages/IpPool';
import OltDashboard from './pages/OltDashboard';
import Contratos from './pages/Contratos';
import Publicidad from './pages/Publicidad';

// Pages (placeholders por ahora)
const Dashboard = () => <div className="text-gray-700"><h2 className="text-2xl font-bold mb-4">Dashboard</h2><p>Bienvenido al CRM.</p></div>;

function App() {
    return (
        <BrowserRouter>
            <ThemeProvider>
                <AuthProvider>
                    <Routes>
                        {/* Rutas públicas */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />

                        {/* Rutas privadas */}
                        <Route path="/dashboard" element={
                            <PrivateRoute>
                                <Layout><Dashboard /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/profile" element={
                            <PrivateRoute>
                                <Layout><Profile /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/users" element={
                            <PrivateRoute permiso={['usuarios', 'read']}>
                                <Layout><Users /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/roles" element={
                            <PrivateRoute permiso={['roles', 'read']}>
                                <Layout><Roles /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/clientes" element={
                            <PrivateRoute permiso={['clientes', 'read']}>
                                <Layout><Clientes /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/zonas" element={
                            <PrivateRoute permiso={['zonas', 'read']}>
                                <Layout><Zonas /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/tecnologias" element={
                            <PrivateRoute permiso={['tecnologias', 'read']}>
                                <Layout><Tecnologias /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/planes" element={
                            <PrivateRoute permiso={['planes', 'read']}>
                                <Layout><Planes /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/inventario/marcas" element={
                            <PrivateRoute permiso={['inv_marcas', 'read']}>
                                <Layout><Marcas /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/inventario/modelos" element={
                            <PrivateRoute permiso={['inv_modelos', 'read']}>
                                <Layout><Modelos /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/inventario/equipos" element={
                            <PrivateRoute permiso={['inv_equipos', 'read']}>
                                <Layout><Equipos /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/infraestructura/nodos" element={
                            <PrivateRoute permiso={['inf_nodos', 'read']}>
                                <Layout><Nodos /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/infraestructura/olt" element={
                            <PrivateRoute permiso={['inf_olt', 'read']}>
                                <Layout><Olt /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/infraestructura/mikrotik" element={
                            <PrivateRoute permiso={['inf_mikrotik', 'read']}>
                                <Layout><Mikrotik /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/infraestructura/ip-pool" element={
                            <PrivateRoute permiso={['inf_ip_pool', 'read']}>
                                <Layout><IpPool /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/monitoreo/olt" element={
                            <PrivateRoute permiso={['inf_olt', 'read']}>
                                <Layout><OltDashboard /></Layout>
                            </PrivateRoute>
                        } />
        <Route path="/contratos" element={
                            <PrivateRoute>
                                <Layout><Contratos /></Layout>
                            </PrivateRoute>
                        } />
        <Route path="/publicidad" element={
                            <PrivateRoute>
                                <Layout><Publicidad /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/settings" element={
                            <PrivateRoute roles={['superadmin', 'admin']}>
                                <Layout><Settings /></Layout>
                            </PrivateRoute>
                        } />

                        {/* Redirect default */}
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </AuthProvider>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
